import { useEffect, useState } from "react";
import {
  FaHome,
  FaUserFriends,
  FaArrowRight,
  FaCheckCircle,
  FaLock,
  FaExclamationTriangle,
  FaChevronRight,
} from "react-icons/fa";
import { LiaCheckCircle } from "react-icons/lia";
import { PiNumberCircleOneLight, PiNumberCircleTwoLight, PiNumberCircleThreeLight } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { getAccessToken } from "../../storage/storage";
import axios from "axios";
import Swal from "sweetalert2";
import { FormatDate } from "../../utils/FormateDate";
import { TableSkelton } from "../../components/Skeletons";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { GoOrganization } from "react-icons/go";
import { FiHome, FiUser, FiUsers, FiCalendar, FiCheckSquare, FiEdit } from "react-icons/fi";
import CommentModal from "./components/CommentModal";
import PageLoader from "../../components/PageLoader"; // Import your PageLoader component
import AlertBanner from "../../components/AlertBanner";

export default function Dashboard() {
  const token = getAccessToken();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const Navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [cleaners, setCleaners] = useState([]);
  const [unassignedGuestStays, setUnassignedGuestStays] = useState([]);
  const [dashboardStats, setDashboardStats] = useState(null);
  const [propertiesInvoices, setPropertiesInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statsLoading, setStatsLoading] = useState(false);
  const [propertiesLoading, setPropertiesLoading] = useState(false);
  const [unassignedLoading, setUnassignedLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [profile, setProfile] = useState(null);

  const PropertyInfo = JSON.parse(sessionStorage.getItem("PropertyData"));
  const CleanerInfo = JSON.parse(sessionStorage.getItem("CleanerData"));
  const companyInfo = JSON.parse(sessionStorage.getItem("companyInfo"));

  // Check if all APIs have loaded
  const allDataLoaded = !statsLoading && !propertiesLoading && !loading && !unassignedLoading;

  const filteredCleaners = cleaners.filter((stay) =>
    stay.property_name.toLowerCase().includes(search.toLowerCase())
  );

  const HandleStays = () => {
    sessionStorage.removeItem("cleanerEdit");
    Navigate("/stays/add-stays");
  };

  // Reusable function to fetch dashboard stats
  const fetchDashboardStats = async () => {
    setStatsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/user/dashboard-stats/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setDashboardStats(response.data);
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    } finally {
      setStatsLoading(false);
    }
  };

  // Fetch dashboard stats on component mount
  useEffect(() => {
    fetchDashboardStats();
  }, []);

  // Fetch properties with pending invoices
  useEffect(() => {
    setPropertiesLoading(true);
    axios
      .get(`${BASE_URL}/api/user/properties/invoice/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setPropertiesInvoices(response.data);
        setPropertiesLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching properties invoices:", error);
        setPropertiesLoading(false);
      });
  }, []);

  // Fetch stays
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/api/stays/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCleaners(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setLoading(false);
      });
  }, []);

  // Fetch unassigned guest stays
  useEffect(() => {
    setUnassignedLoading(true);
    axios
      .get(`${BASE_URL}/api/unassigned-guest-stays/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("unassigned-guest-stays " + response.data);
        setUnassignedGuestStays(response.data);
        setUnassignedLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching options:", error);
        setUnassignedLoading(false);
      });
  }, []);

  // Fetch profile — used only for the header's "Good morning, {name}" greeting
  // and the sidebar's identity chip; same /api/profile/ endpoint Routing.js
  // already calls at app load, no new data.
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/profile/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => setProfile(response.data))
      .catch(() => {
        // Decorative — silently skip if it fails.
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTaskSheetClick = (id) => {
    Navigate(`/task-sheet/${id}`);
  };

  const handleInvoiceClick = (guestStayId) => {
    Navigate(`/invoice/${guestStayId}`);
  };

  const handleAddCleaner = (stay) => {
    sessionStorage.setItem("cleanerEdit", JSON.stringify(true));
    Navigate("/stays/add-stays", { state: { stay } });
  };

  const handleViewAllStays = () => {
    Navigate("/stays");
  };

  const handleViewAllInvoices = () => {
    Navigate("/invoices");
  };

  // Handle approve invoice
  const handleApproveInvoice = async (invoiceId) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/api/invoices/${invoiceId}/approve/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Remove the approved invoice from the list
      setPropertiesInvoices(prev =>
        prev.map(property => ({
          ...property,
          pending_invoices: property.pending_invoices.filter(inv => inv.id !== invoiceId),
          pending_invoices_count: property.pending_invoices_count -
            (property.pending_invoices.some(inv => inv.id === invoiceId) ? 1 : 0)
        }))
      );
// Refresh dashboard stats after approval
      fetchDashboardStats();
      // Show success message
      Swal.fire({
        icon: "success",
        title: response?.data?.message || "Invoice Approved",
        timer: 2000,
        showConfirmButton: false,
        position: "center",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response?.data?.detail || "Something went wrong!",
        timer: 2000,
        showConfirmButton: false,
        position: "center",
      });
    }
  };

  // Handle reject invoice - open modal
  const handleRejectInvoice = (invoice) => {
    setSelectedInvoice(invoice);
    setIsOpenModal(true);
  };

  const getPropertyColor = (color) => {
    const colorMap = {
      "Pink": "#FF69B4",
      "Teal": "#008080",
      "Blue": "#0000FF",
      "Green": "#008000",
      "Purple": "#800080",
      "Orange": "#FFA500",
      "Red": "#FF0000",
      "Yellow": "#FFD700",
    };
    return colorMap[color] || "#6B7280"; // Default gray color
  };

  // Handle reject confirmation from modal
  const handleRejectConfirm = (invoiceId) => {
    // Remove the rejected invoice from the list
    setPropertiesInvoices(prev =>
      prev.map(property => ({
        ...property,
        pending_invoices: property.pending_invoices.filter(inv => inv.id !== invoiceId),
        pending_invoices_count: property.pending_invoices_count -
          (property.pending_invoices.some(inv => inv.id === invoiceId) ? 1 : 0)
      }))
    );
    fetchDashboardStats();
    setIsOpenModal(false);
    setSelectedInvoice(null);
  };

  // Generate invoices for approval from the new API response
  const generateInvoicesForApproval = () => {
    const invoices = [];

    propertiesInvoices.forEach(property => {
      property.pending_invoices.forEach(invoice => {
        invoices.push({
          id: invoice.id,
          invoiceNumber: invoice.invoice_number,
          cleanerName: `${invoice.cleaner.first_name} ${invoice.cleaner.surname}`,
          serviceType: "Cleaning Service",
          propertyName: invoice.property,
          amount: invoice.total_amount,
          completionDate: invoice.created_at ? FormatDate(invoice.created_at) : "N/A",
          status: invoice.status.toUpperCase(),
          comments: invoice.comments,
          cleanerEmail: invoice.cleaner.email,
          subtotal: invoice.subtotal
        });
      });
    });

    return invoices;
  };

  const invoicesForApproval = generateInvoicesForApproval();

  // Calculate completion status
  const completedTasks = [companyInfo, PropertyInfo, CleanerInfo].filter(Boolean).length;
  const totalTasks = 3;
  const completionPercentage = (completedTasks / totalTasks) * 100;
  const isSetupComplete = completedTasks === totalTasks;

  // ── Presentational-only derivations for the new header/checklist styling ──
  // (all driven by the same completedTasks/companyInfo/PropertyInfo/CleanerInfo
  // values already computed above — no new data sources)
  const activeStepIndex = completedTasks; // 0=profile next, 1=property next, 2=cleaner next
  const nextStepRoute = !companyInfo ? "/" : !PropertyInfo ? "/property" : "/invite-cleaner";
  const greetingName = profile?.first_name || "";
  const todayLabel = new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const headerSubtitle = !isSetupComplete
    ? (completedTasks === 0 ? "welcome! let's get you set up" : "complete setup to get started")
    : `${dashboardStats?.total_properties || 0} propert${(dashboardStats?.total_properties || 0) === 1 ? "y" : "ies"} · ${dashboardStats?.total_active_cleaners || 0} active cleaner${(dashboardStats?.total_active_cleaners || 0) === 1 ? "" : "s"}`;

  const gettingStartedCopy = [
    {
      headline: `Welcome to HouseKeeper${greetingName ? `, ${greetingName}` : ""}! 👋`,
      body: "You're just a few minutes away from having your short-term rental cleaning fully organised. Complete the three setup steps to get started.",
      tip: "Tip: Start with your profile — it only takes about two minutes.",
    },
    {
      headline: "Great start — profile complete!",
      body: "Now add your first property. Once it's set up you can invite your cleaners and start scheduling stays.",
      tip: "Tip: Have your property address and access instructions ready.",
    },
    {
      headline: "Property added — one step to go!",
      body: "Invite your cleaners by email. Once they accept and set up their profile, you can assign them to stays and they can submit invoices.",
      tip: "Tip: Your cleaner will receive an email with a link to join HouseKeeper.",
    },
  ][Math.min(activeStepIndex, 2)];

  const setupSteps = [
    {
      key: "profile",
      title: "Complete your profile",
      description: "Add your business details and contact information",
      done: !!companyInfo,
    },
    {
      key: "property",
      title: "Add your first property",
      description: "Register property details and cleaning requirements",
      done: !!PropertyInfo,
    },
    {
      key: "cleaner",
      title: "Invite your cleaners",
      description: "Build your team of trusted cleaning professionals",
      done: !!CleanerInfo,
    },
  ];

  const renderStepNumberIcon = (index) => {
    if (index === 0) return <PiNumberCircleOneLight className="text-xl" />;
    if (index === 1) return <PiNumberCircleTwoLight className="text-xl" />;
    return <PiNumberCircleThreeLight className="text-xl" />;
  };

  // Show loader until all data is loaded
  if (!allDataLoaded) {
    return <PageLoader />;
  }

  return (
    <div className="flex flex-col gap-6 px-6 w-full h-full pb-8">

      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-[#586989]">
            Good morning{greetingName ? `, ${greetingName}` : ""}
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">
            {todayLabel} — {headerSubtitle}
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          {isSetupComplete ? (
            <>
              <Link
                to="/invite-cleaner"
                className="flex items-center gap-2 border-2 border-[#586989] text-[#586989] px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
              >
                <FiUser /> Invite cleaner
              </Link>
              <Link
                to="/property"
                onClick={() => sessionStorage.removeItem("edit")}
                className="flex items-center gap-2 bg-[#586989] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#47546d] transition-colors"
              >
                + Add property
              </Link>
            </>
          ) : (
            <Link
              to={nextStepRoute}
              className="flex items-center gap-2 bg-[#FFF5CE] text-[#586989] px-4 py-2 rounded-lg text-sm font-semibold hover:bg-[#fdeeb0] transition-colors"
            >
              Continue setup <FaArrowRight className="text-xs" />
            </Link>
          )}
        </div>
      </div>

      {/* Full Width Important Information */}
      <div className="w-full">
        {unassignedGuestStays?.unassigned_stays?.length > 0 ? (
          <div className="space-y-2">
            {unassignedGuestStays.unassigned_stays.map((stay) => (
              <AlertBanner
                key={stay.id}
                variant="failure"
                icon={<FaExclamationTriangle className="text-lg" />}
                action={
                  <button
                    onClick={() => Navigate("/stays")}
                    className="flex-shrink-0 bg-red-500 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors"
                  >
                    Assign cleaner
                  </button>
                }
              >
                <p className="font-semibold text-[#586989]">{stay.property_name}</p>
                <p className="text-sm">
                  Stay #{stay.id} has no cleaner assigned
                  {stay.check_in_date ? ` — check-in is ${FormatDate(stay.check_in_date)}` : ""}
                </p>
              </AlertBanner>
            ))}
          </div>
        ) : (
          <div className="bg-[#FFF5CE] border-l-4 border-blue-500 text-blue-800 p-4 rounded-r-lg w-full">
            <div className="flex items-start">
              <FaCheckCircle className="text-blue-500 text-xl mt-1 mr-3 flex-shrink-0" />
              <div>
                <p className="font-semibold text-[#586989]">Welcome to Your Dashboard!</p>
                <p className="text-sm text-[#586989]">All upcoming stays are currently assigned. You're all set!</p>

              </div>
            </div>
          </div>
        )}
      </div>

      {/* Full Width Dashboard Stats Cards */}
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
          {/* Total Properties Card */}
          <div
          onClick={() => Navigate("/settings/properties")}
          className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm w-full cursor-pointer hover:shadow-md hover:bg-gray-50 transition-all duration-200"
        >
          <div className="flex flex-col items-center justify-center">
            <div className="bg-[#FFF5CE] p-3 rounded-lg mb-4">
              <FiHome className="text-[#586989] text-2xl" />
            </div>
            <p className="text-3xl font-bold text-[#586989] mb-2">
              {statsLoading ? "..." : (dashboardStats?.total_properties || 0)}
            </p>
            <p className="text-sm text-gray-600 font-medium">Total Properties</p>
            {dashboardStats?.total_properties <= 0 && <p className="text-xs text-gray-600 font-xs">
              Ready to add your first property
            </p>}
          </div>
          </div>
          {/* Active Cleaners Card */}
          <div
          onClick={() => Navigate("/settings/cleaners")}
          className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm w-full cursor-pointer hover:shadow-md hover:bg-gray-50 transition-all duration-200"
        >
          <div className="flex flex-col items-center justify-center">
            <div className="bg-[#FFF5CE] p-3 rounded-lg mb-4">
              <FiUsers className="text-[#586989] text-2xl" />
            </div>
            <p className="text-3xl font-bold text-[#586989] mb-2">
              {statsLoading ? "..." : (dashboardStats?.total_active_cleaners || 0)}
            </p>
            <p className="text-sm text-gray-600 font-medium">Active Cleaners</p>
            {dashboardStats?.total_active_cleaners <= 0 && <p className="text-xs text-gray-600 font-xs">
              Invite cleaners to get started
            </p>}
          </div>
        </div>

          {/* Stays Without Cleaners Card */}
          {isSetupComplete ? (
            <div
              onClick={() => Navigate("/stays")}
              className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm w-full cursor-pointer hover:shadow-md hover:bg-gray-50 transition-all duration-200"
            >
              <div className="flex flex-col items-center justify-center">
                <div className="bg-[#FFF5CE] p-3 rounded-lg mb-4">
                  <FiCalendar className="text-[#586989] text-2xl" />
                </div>
                <p className={`text-3xl font-bold mb-2 ${(dashboardStats?.total_stays_without_cleaners || 0) > 0 ? "text-red-500" : "text-[#586989]"}`}>
                  {statsLoading ? "..." : (dashboardStats?.total_stays_without_cleaners || 0)}
                </p>
                <p className="text-sm text-gray-600 font-medium">Stays Without Cleaners</p>
                <p className="text-xs text-gray-600 font-xs">
                  {(dashboardStats?.total_stays_without_cleaners || 0) > 0 ? "Click to view" : "Stay requiring cleaner assignment"}
                </p>
              </div>
            </div>
          ) : (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 shadow-sm w-full opacity-70">
              <div className="flex flex-col items-center justify-center">
                <div className="bg-gray-200 p-3 rounded-lg mb-4">
                  <FaLock className="text-gray-400 text-xl" />
                </div>
                <p className="text-sm text-gray-500 font-medium text-center">Stays without cleaners</p>
                <p className="text-xs text-gray-400 mt-1">Complete setup to unlock</p>
              </div>
            </div>
          )}

          {/* Invoices for Approval Card */}
          {isSetupComplete ? (
            <div
              onClick={() => Navigate("/stays")}
              className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm w-full cursor-pointer hover:shadow-md hover:bg-gray-50 transition-all duration-200"
            >
              <div className="flex flex-col items-center justify-center">
                <div className="bg-[#FFF5CE] p-3 rounded-lg mb-4">
                  <FiEdit className="text-[#586989] text-2xl" />
                </div>
                <p className={`text-3xl font-bold mb-2 ${(dashboardStats?.total_pending_invoices || 0) > 0 ? "text-red-500" : "text-[#586989]"}`}>
                  {statsLoading ? "..." : (dashboardStats?.total_pending_invoices || 0)}
                </p>
                <p className="text-sm text-gray-600 font-medium">Invoices for Approval</p>
                <p className="text-xs text-gray-600 font-xs">
                  {(dashboardStats?.total_pending_invoices || 0) > 0 ? "Click to view" : "Tasks requiring approval"}
                </p>
              </div>
            </div>
          ) : (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 shadow-sm w-full opacity-70">
              <div className="flex flex-col items-center justify-center">
                <div className="bg-gray-200 p-3 rounded-lg mb-4">
                  <FaLock className="text-gray-400 text-xl" />
                </div>
                <p className="text-sm text-gray-500 font-medium text-center">Invoices for approval</p>
                <p className="text-xs text-gray-400 mt-1">Complete setup to unlock</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Two Column Layout for Content */}
      <div className="flex flex-col lg:flex-row gap-6 w-full">
        {/* Left Column - Getting Started (incomplete) or Upcoming Stays (complete) */}
        <div className="flex-1">
          {isSetupComplete ? (
            /* Upcoming Stays Section */
            <div className=" bg-white border border-gray-200 rounded-lg shadow-sm mb-6">
              <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h2 className="text-xl font-bold text-[#586989]">Upcoming Stays</h2>
                <div className="flex items-center gap-4">
                  <button
                    onClick={handleViewAllStays}
                    className="text-sm text-[#586989] hover:text-blue-800 flex items-center gap-1"
                  >
                    View All <FaArrowRight className="text-xs" />
                  </button>
                </div>
              </div>

              {/* Scrollable content area */}
              <div className="p-4 max-h-[645px] overflow-y-auto">
                <div className="space-y-4">
                  {loading ? (
                    <div className="flex justify-center items-center h-32">
                      <TableSkelton />
                    </div>
                  ) : filteredCleaners.length > 0 ? (
                    filteredCleaners.map((stay, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors">
                        <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                          {/* ID + status */}
                          <div className="flex items-center gap-2 flex-shrink-0">
                            <div className="px-3 py-1 rounded" style={{ backgroundColor: getPropertyColor(stay?.property_details?.property_color), opacity: 0.6 }}>
                              <span className="text-sm font-medium" style={{ color: 'white' }}>#{stay.id}</span>
                            </div>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${stay.status === 'CONFIRMED' ? 'bg-green-100 text-green-800' :
                              stay.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                              stay.status === 'REJECTED' ? 'bg-red-100 text-red-800' :
                                stay.status === 'ACCEPTED' ? 'bg-blue-100 text-blue-800' :
                                  'bg-gray-100 text-gray-800'
                              }`}>
                              {stay.status || 'Pending'}
                            </span>
                          </div>

                          {/* Property */}
                          <div className="flex items-center gap-2 min-w-0 lg:w-40 flex-shrink-0">
                            <FaHome className="text-gray-400 text-sm flex-shrink-0" />
                            <p className="text-sm text-blue-600 truncate" title={stay.property_name}>{stay.property_name}</p>
                          </div>

                          {/* Check-in */}
                          <div className="lg:w-28 flex-shrink-0">
                            <p className="text-sm font-medium text-gray-700">{FormatDate(stay.check_in_date)}</p>
                            <p className="text-xs text-gray-400">Check-in</p>
                          </div>

                          {/* Check-out */}
                          <div className="lg:w-28 flex-shrink-0">
                            <p className="text-sm font-medium text-gray-700">{FormatDate(stay.check_out_date)}</p>
                            <p className="text-xs text-gray-400">Check-out</p>
                          </div>

                          {/* Invoice status, if any */}
                          {stay?.invoices[0]?.status && (
                            <span className={`flex-shrink-0 px-2 py-1 rounded text-xs ${stay.invoices[0].status === 'approved' ? 'bg-green-100 text-green-800' :
                              stay.invoices[0].status === 'paid' ? 'bg-blue-100 text-blue-800' :
                                stay.invoices[0].status === 'rejected' ? 'bg-red-100 text-red-800' :
                                  'bg-gray-100 text-gray-800'
                              }`}>
                              Invoice: {stay.invoices[0].status.toUpperCase()}
                            </span>
                          )}

                          {/* Cleaner / Assign + actions, right-aligned */}
                          <div className="flex items-center gap-2 flex-wrap lg:ml-auto lg:justify-end">
                            {stay?.cleaner_name ? (
                              <span className="flex items-center gap-1 text-sm text-gray-600">
                                <FaUserFriends className="text-gray-400 text-xs" />
                                {stay.cleaner_name}
                              </span>
                            ) : (
                              <button
                                onClick={() => handleAddCleaner(stay)}
                                className="bg-[#586989] text-white px-3 py-1.5 rounded text-sm font-medium hover:bg-[#47546d] transition-colors"
                              >
                                Assign
                              </button>
                            )}
                            <button
                              onClick={() => handleAddCleaner(stay)}
                              className="text-gray-500 hover:text-gray-700 p-1.5 rounded-full hover:bg-gray-200 transition-colors"
                              title="View Details"
                            >
                              <MdOutlineRemoveRedEye className="text-lg" />
                            </button>
                            {stay.status === "ACCEPTED" && (
                              <>
                                <button
                                  onClick={() => handleTaskSheetClick(stay.id)}
                                  className="px-2.5 py-1 bg-blue-600 text-white rounded text-xs font-medium hover:bg-blue-700 transition-colors"
                                >
                                  Task Sheet
                                </button>
                                <button
                                  onClick={() => handleInvoiceClick(stay.id)}
                                  className="px-2.5 py-1 bg-green-600 text-white rounded text-xs font-medium hover:bg-green-700 transition-colors"
                                >
                                  Invoice
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-gray-500 py-8">
                      No upcoming stays found
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            /* Getting Started panel (main content while onboarding incomplete) */
            <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-6">
              <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <h2 className="text-lg font-bold text-[#586989]">Getting Started</h2>
                <span className="text-sm text-gray-500">{completedTasks}/3 complete</span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-bold text-[#586989] mb-1">{gettingStartedCopy.headline}</h3>
                <p className="text-sm text-gray-600 mb-3">{gettingStartedCopy.body}</p>
                <div className="bg-[#FFF5CE] border border-[#f0d98c] text-sm text-[#8a6d1a] rounded-lg px-4 py-2 mb-4">
                  {gettingStartedCopy.tip}
                </div>

                <div className="space-y-4">
                  {setupSteps.map((step, index) => {
                    const isCurrent = !step.done && index === activeStepIndex;
                    const isFuture = !step.done && index > activeStepIndex;
                    return (
                      <div key={step.key} className="flex items-start gap-3">
                        <div className="mt-0.5 flex-shrink-0">
                          {step.done ? (
                            <LiaCheckCircle className="text-2xl text-green-500" />
                          ) : isCurrent ? (
                            <span className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-orange-400 text-orange-500 text-xs font-bold">
                              {index + 1}
                            </span>
                          ) : (
                            <span className="text-gray-300">{renderStepNumberIcon(index)}</span>
                          )}
                        </div>
                        <div className="flex-1">
                          <h4 className={`font-medium ${step.done ? "text-gray-400 line-through" : isFuture ? "text-gray-400" : "text-gray-800"}`}>
                            {step.title}
                          </h4>
                          <p className={`text-sm mt-0.5 ${isFuture ? "text-gray-300" : "text-gray-500"}`}>
                            {step.description}
                          </p>
                          {isCurrent && step.key === "profile" && (
                            <Link
                              to="/"
                              className="inline-block mt-2 text-sm bg-[#586989] text-white px-3 py-1.5 rounded hover:bg-[#47546d] transition-colors"
                            >
                              Complete profile
                            </Link>
                          )}
                          {isCurrent && step.key === "property" && (
                            <div className="flex flex-wrap gap-2 mt-2">
                              <Link
                                to="/lodgify/1"
                                className="inline-block text-sm bg-[#586989] text-white px-3 py-1.5 rounded hover:bg-[#47546d] transition-colors"
                              >
                                Connect Channel Manager
                              </Link>
                              <Link
                                to="/property"
                                onClick={() => sessionStorage.removeItem("edit")}
                                className="inline-block text-sm bg-[#586989] text-white px-3 py-1.5 rounded hover:bg-[#47546d] transition-colors"
                              >
                                Add property
                              </Link>
                            </div>
                          )}
                          {isCurrent && step.key === "cleaner" && (
                            <Link
                              to="/invite-cleaner"
                              className="inline-block mt-2 text-sm bg-[#586989] text-white px-3 py-1.5 rounded hover:bg-[#47546d] transition-colors"
                            >
                              Invite cleaners
                            </Link>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Right Column - condensed Getting Started (incomplete) or Invoices + Quick Actions (complete) */}
        <div className="lg:w-80 w-full">
          {isSetupComplete ? (
            <>
              {/* Invoices for Approval */}
              {invoicesForApproval.length > 0 && (
                <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-4">
                  <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h3 className="font-bold text-[#586989]">Invoices for approval</h3>
                    {/* <button
                      onClick={handleViewAllInvoices}
                      className="text-xs text-[#586989] hover:text-blue-800 flex items-center gap-1"
                    >
                      View all <FaArrowRight className="text-[10px]" />
                    </button> */}
                  </div>
                  <div className="p-4">
                    {/* Scrollable list — capped height so a long queue doesn't push
                        Quick Actions off screen; "Total outstanding" stays pinned below. */}
                    <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1">
                      {invoicesForApproval.map((invoice, index) => (
                        <div key={index} className="border border-gray-200 rounded-lg p-3">
                          <div className="flex justify-between items-start mb-1">
                            <p className="text-sm font-semibold text-gray-800">{invoice.invoiceNumber} · Stay</p>
                            <p className="text-sm font-bold text-gray-800">£{invoice.amount}</p>
                          </div>
                          <p className="text-xs text-gray-500 mb-2">
                            {invoice.cleanerName} · {invoice.serviceType}
                          </p>
                          <div className="flex gap-2">
                            <button
                              onClick={() => handleApproveInvoice(invoice.id)}
                              className="flex-1 px-3 py-1 bg-green-600 text-white rounded text-xs font-medium hover:bg-green-700"
                            >
                              Approve
                            </button>
                            <button
                              onClick={() => handleRejectInvoice(invoice)}
                              className="flex-1 px-3 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium hover:bg-gray-200"
                            >
                              Reject
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="flex justify-between items-center pt-3 mt-1 border-t border-gray-200 text-sm">
                      <span className="text-gray-500">Total outstanding</span>
                      <span className="font-bold text-gray-800">
                        £{invoicesForApproval.reduce((sum, inv) => sum + Number(inv.amount || 0), 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* Quick Actions */}
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
                <div className="p-4 border-b border-gray-200">
                  <h3 className="font-bold text-[#586989]">Quick actions</h3>
                </div>
                <div className="p-2">
                  <Link
                    to="/invite-cleaner"
                    className="flex items-center gap-3 p-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    <div className="bg-[#FFF5CE] p-2 rounded-lg">
                      <FiUser className="text-[#586989]" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-gray-800 text-sm">Invite a cleaner</p>
                      <p className="text-xs text-gray-500">Send an invite by email</p>
                    </div>
                    <FaChevronRight className="text-gray-300 text-xs" />
                  </Link>
                  <Link
                    to="/property"
                    onClick={() => sessionStorage.removeItem("edit")}
                    className="flex items-center gap-3 p-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    <div className="bg-[#FFF5CE] p-2 rounded-lg">
                      <FaHome className="text-[#586989]" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-gray-800 text-sm">Add a property</p>
                      <p className="text-xs text-gray-500">Register a new short-term rental</p>
                    </div>
                    <FaChevronRight className="text-gray-300 text-xs" />
                  </Link>
                  <Link
                    to="/other-tasks"
                    className="flex items-center gap-3 p-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                  >
                    <div className="bg-[#FFF5CE] p-2 rounded-lg">
                      <FiEdit className="text-[#586989]" />
                    </div>
                    <div className="flex-1">
                      <p className="font-medium text-gray-800 text-sm">View ad hoc tasks</p>
                      <p className="text-xs text-gray-500">Non-stay cleaning tasks</p>
                    </div>
                    <FaChevronRight className="text-gray-300 text-xs" />
                  </Link>
                </div>
              </div>
            </>
          ) : (
            /* Condensed Getting Started mirror */
            <div className="bg-[#FFF5CE] border border-[#f0d98c] rounded-lg shadow-sm p-4">
              <h3 className="font-bold text-[#586989] mb-2">Getting started</h3>
              <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
                <span>Setup progress</span>
                <span className="font-semibold text-[#586989]">{Math.round(completionPercentage)}%</span>
              </div>
              <div className="w-full bg-white/70 rounded-full h-2 mb-1">
                <div
                  className="h-2 rounded-full bg-[#586989] transition-all duration-300"
                  style={{ width: `${completionPercentage}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mb-4">
                {completedTasks} of {totalTasks} steps complete
              </p>

              <div className="space-y-3">
                {setupSteps.map((step, index) => {
                  const isCurrent = !step.done && index === activeStepIndex;
                  return (
                    <div key={step.key} className="flex items-start gap-2">
                      {step.done ? (
                        <LiaCheckCircle className="text-lg text-green-500 mt-0.5 flex-shrink-0" />
                      ) : isCurrent ? (
                        <span className="flex items-center justify-center w-5 h-5 rounded-full border-2 border-orange-400 text-orange-500 text-[10px] font-bold flex-shrink-0 mt-0.5">
                          {index + 1}
                        </span>
                      ) : (
                        <span className="text-gray-300 flex-shrink-0">{renderStepNumberIcon(index)}</span>
                      )}
                      <div>
                        <p className={`text-sm font-medium ${step.done ? "text-gray-400 line-through" : "text-gray-700"}`}>
                          {step.title}
                        </p>
                        <p className="text-xs text-gray-500">{step.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Comment Modal for Reject */}
      <CommentModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        invoiceId={selectedInvoice?.id}
        onRejectConfirm={handleRejectConfirm}
      />
    </div>
  );
}
